module.exports = __webpack_public_path__ + "static/img/anger2.30e90ea5.png";